import { render } from "./other_setting.vue?vue&type=template&id=78d55444&scoped=true"
import script from "./other_setting.vue?vue&type=script&lang=js"
export * from "./other_setting.vue?vue&type=script&lang=js"

import "./other_setting.vue?vue&type=style&index=0&id=78d55444&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d55444"]])

export default __exports__